import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IpCheckPage } from '@zg-rentals/particles-js-ip-check';
import { Container } from '@zillow/zrs-comet';

import AppActions from 'app/shared/actions/AppActions';
import HeadWrapper from 'app/shared/components/HeadWrapper';

const IpCheckPageWrapper = () => {
    const dispatch = useDispatch();
    const fullReqIps = useSelector(state => state.app.fullReqIps);
    const ip = useSelector(state => state.app.ip);
    const ipFromApi = useSelector(state => state.app.ipFromJava);
    const [browserIpFromApi, setBrowserIpFromApi] = useState({});
    const [browserIpFromApiNoProxy, setBrowserIpFromApiNoProxy] = useState({});

    useEffect(() => {
        dispatch(AppActions.getIp()).then((response) => {
            if (response && typeof response === 'object' && response.success !== false) {
                setBrowserIpFromApi(response);
            }
        });

        dispatch(AppActions.getIp(true)).then((response) => {
            if (response && typeof response === 'object' && response.success !== false) {
                setBrowserIpFromApiNoProxy(response);
            }
        });
    }, []);

    return (
        <Container>
            <HeadWrapper noFollow={true} noIndex={true} />
            <IpCheckPage
                nodeDetectedIp={ip}
                serverIpsFromNode={fullReqIps}
                serverIpsFromApi={ipFromApi}
                browserIpsFromApi={browserIpFromApi}
                browserIpsFromApiNoProxy={browserIpFromApiNoProxy}
            />
        </Container>

    );
};


export default IpCheckPageWrapper;
